import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaControleInternoRecursoConcedidoInicio: [],
    buscaControleInternoRecursoConcedidoSucesso: ['controleInternoRecursoConcedido'],
    buscaControleInternoRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaControleInternoRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaControleInternoRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarControleInterno(filtro)
            .then(response => dispatch(Creators.buscaControleInternoRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaControleInternoRecursoConcedidoErro(error)))
    }
}

const buscaControleInternoRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaControleInternoRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaControleInternoRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.controleInternoRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONTROLE_INTERNO_RECURSO_CONCEDIDO_INICIO]: buscaControleInternoRecursoConcedidoInicio,
    [Types.BUSCA_CONTROLE_INTERNO_RECURSO_CONCEDIDO_ERRO]: buscaControleInternoRecursoConcedidoErro,
    [Types.BUSCA_CONTROLE_INTERNO_RECURSO_CONCEDIDO_SUCESSO]: buscaControleInternoRecursoConcedidoSucesso,
})
